import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.AppConfig.';
  public static readonly dashboard = `${Id.prefix}dashboard`;
  public static readonly projects = `${Id.prefix}projects`;
  public static readonly quotes = `${Id.prefix}quotes`;
  public static readonly purchaseOrders = `${Id.prefix}purchaseOrders`;
  public static readonly supportTickets = `${Id.prefix}supportTickets`;
  public static readonly clients = `${Id.prefix}clients`;
  public static readonly settings = `${Id.prefix}settings`;
}

export class LangAppConfig {
  private constructor() {}

  public static dashboard(): string {
    return interpolate(Id.dashboard);
  }

  public static projects(): string {
    return interpolate(Id.projects);
  }

  public static quotes(): string {
    return interpolate(Id.quotes);
  }

  public static purchaseOrders(): string {
    return interpolate(Id.purchaseOrders);
  }

  public static supportTickets(): string {
    return interpolate(Id.supportTickets);
  }

  public static clients(): string {
    return interpolate(Id.clients);
  }

  public static settings(): string {
    return interpolate(Id.settings);
  }
}

export class AppConfigModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.dashboard, 'Dashboard', 'Menu label for dashboard');
    register.add(Id.projects, "{{glossary 'project:plural'}}", 'Menu label for projects');
    register.add(Id.quotes, "{{glossary 'quote:plural'  }}", 'Menu label for quotes');
    register.add(Id.purchaseOrders, "{{glossary 'purchase-order:plural'}}", 'Menu label for purchase orders');
    register.add(Id.supportTickets, 'Support Tickets', 'Menu label for support tickets');
    register.add(Id.clients, "{{glossary 'client:plural'}}", 'Menu label for clients');
    register.add(Id.settings, 'Settings', 'Menu label for settings');
  }
}
